// js
import React from 'react';
import PropTypes from 'prop-types';
import SecurityDetail from '../../containers/analytics/SecurityDetail';

const SecurityNonCriticalAcceptableDetail = ({ data }) => {
  return (
    <SecurityDetail
      data={data}
      criticality='nonCritical'
      adequacy='acceptable'
    />
  );
};

SecurityNonCriticalAcceptableDetail.propTypes = {
  data: PropTypes.object.isRequired
};

export default SecurityNonCriticalAcceptableDetail;



// WEBPACK FOOTER //
// ./src/components/analytics/SecurityNonCriticalAcceptableDetail.js